import { ProductDepartmentDetailPage } from '@/features/product-department/pages/ProductDepartmentDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-department/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_department.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductDepartmentDetailPage,
})
